<template>
     <div class="site-view">
      <Header :title="Privacy"/>
      
 
        <section class="page-section video-section">
       
            <div class="container">
                <div class="row">
                    <div class="col m12 l12">
                        <div class="text-wrap center-align">
                            <div class="mb4">
                                <p class="hr-title mb4"><hr class="hr-purple"><b>Privacy Policy</b></p>
                                <h1>Freedom of Information Act 2000 - Confidentiality of Consultations</h1>
                                <p class="mb2">
                                    The Freedom of Information Act gives the public a right
                                    of access to any information held by a public authority,
                                    namely, the Department in this case. This right of
                                    access to information includes information provided
                                    in response to a consultation. The Department cannot
                                    automatically consider as confidential information
                                    supplied to it in response to a consultation. However
                                    it does have the responsibility to decide whether
                                    any information provided by you in response to this
                                    consultation, including information about your identity,
                                    should be made public or treated as confidential.
                                </p>
                                <p class="mb2">
                                    This means that information provided by you in
                                    response to the consultation is unlikely to be
                                    treated as confidential, except in very particular
                                    circumstances. The Lord Chancellor’s Code of
                                    Practice on the Freedom of Information Act
                                    provides that: The Department should only accept
                                    information from third parties in confidence if it is
                                    necessary to obtain that information in connection
                                    with the exercise of any of the Department’s
                                    functions and it would not otherwise be provided
                                </p>
                                <p class="mb2">
                                    The Department should not agree to hold information
                                    received from third parties ‘in confidence’ which
                                    is not confidential in nature. Acceptance by
                                    the Department of confidentiality provisions
                                    must be for good reasons, capable of being
                                    justified to the Information commissioner
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <TwoColumnFooter/>
        <Footer />
    </div>
</template>

<script>
import TwoColumnFooter from "@/components/belfast/TwoColumnFooter";


import Footer from "@/components/belfast/Footer";
//import Header from "@/components/belfast/HeroHeaderOtherPages"
import Header from "@/components/belfast/Header";
export default {
  name: "pagePrivacy",
   components: {
    Header,
    Footer,
    TwoColumnFooter
  },
  data() {
    return {
       Privacy:"Privacy Policy"
    }
  }
};
</script>
